<style lang="scss" scoped>
input {
    transition: border-color 0.3s;
    color: var(--dark);

    &.error {
        border-color: var(--danger);
    }
    &:focus {
        box-shadow: none !important;
    }
    &::placeholder {
        color: rgba(51, 51, 51, 0.5) !important;
    }
    &:-ms-input-placeholder {
        color: rgba(51, 51, 51, 0.5) !important;
    }
    &::-ms-input-placeholder {
        color: rgba(51, 51, 51, 0.5) !important;
    }
}
.form-group:not(.small) {
    input {
        padding: 1rem;
        height: 56px;
    }
}
.form-group.small {
    input {
        padding: 0.5rem 1rem;
        height: 40px;
    }
}
.form-group:not(.no-top-margin) {
    input,
    textarea {
        margin-top: 10px;
    }
}
textarea {
    padding: 0.625rem 1rem;
    &.error {
        border-color: var(--danger);
    }
}
textarea,
.form-control {
    transition: border 0.2s;
    border: 1px solid var(--border-color);
    font-size: 1rem;
    font-weight: 400;
    &:focus {
        border: 1px solid var(--primary);
    }
}
label,
.label-error {
    margin-bottom: 0;
    background: #fff;
    left: 11px;
    top: 0px;
    padding: 0;
    color: var(--dark);
    font-weight: 400;
    line-height: 22px;
    display: flex;
}
.label-error {
    color: var(--danger);
    font-weight: 700;
}
.input-cta {
    position: absolute;
    top: 19px;
    right: 20px;
    color: var(--primary-dark);
}
</style>

<template>
    <div class="form-group position-relative">
        <label v-if="(!errors.has(name, scope) && !forcedError) && hasLabel" :for="_uid + 'Id'" class="small">
            <span v-html="label"></span>
            <slot name="label-cta">

            </slot>
        </label>
        <span v-else class="label-error small">{{ forcedError || errors.first(name, scope) }}</span>
        <div class="position-relative">
            <div v-if="hasInputCta" class="input-cta small" ref="inputCta">
                <slot name="input-cta">

                </slot>
            </div>
            <textarea v-if="type === 'textarea'" class="w-100 form-control" :value="localValue" :class="[{ error : forcedError || errors.has(name, scope)}, `tc_${name}_${type}`]" :data-vv-as="as" v-validate="rule" :name="name" :id="_uid + 'Id'" :aria-describedby="_uid + 'Desc'" :placeholder="placeholder" :rows="rows" :disabled="disabled" :data-vv-validate-on="validateOn" v-on="inputListeners" :data-vv-scope="scope"></textarea>
            <input v-else-if="type === 'time'" class="form-control" :step="step" :value="localValue" :class="[{ error : forcedError || errors.has(name, scope), 'mt-0' : !hasLabel }, `tc_${name}_${type}`]" :data-vv-as="as" v-validate="typeof rule === 'string' ? `${rule}|date_format:HH:mm|step:${step}` : Object.assign({ date_format: 'HH:mm', step: step }, rule)" :type="type" :name="name" :id="_uid + 'Id'" :aria-describedby="_uid + 'Desc'" :placeholder="placeholder" :style="{ 'padding-right': inputCtaWidth }" :disabled="disabled" :data-vv-validate-on="validateOn" v-on="inputListeners" :data-vv-scope="scope">
            <input v-else class="form-control" :value="localValue" :class="[{ error : forcedError || errors.has(name, scope), 'mt-0' : !hasLabel }, `tc_${name}_${type}`]" :data-vv-as="as" v-validate="rule" :type="type" :name="name" :id="_uid + 'Id'" :aria-describedby="_uid + 'Desc'" :placeholder="placeholder" :style="{ 'padding-right': inputCtaWidth }" :disabled="disabled" :step="step" :data-vv-validate-on="validateOn" v-on="inputListeners" :data-vv-scope="scope">
        </div>
        <small v-if="description.length > 0" class="form-text text-muted" :id="_uid + 'Desc'">{{ description }}</small>
    </div>
</template>

<script>
export default {
    inject: ['$validator'],
    props: {
        /**
         * String, Number defining the value
         * @type {String, Number}
         */
        value: {
            type: [String, Number],
            default: '',
        },

        /**
         * String defining the input type
         * @type {String}
         */
        type: {
            type: String,
            default: 'text',
        },

        /**
         * String defining the input name
         * @type {String}
         */
        name: {
            type: String,
            default: '',
        },

        /**
         * String defining the input name
         * @type {String}
         */
        as: {
            type: String,
            default: '',
        },

        /**
         * String defining the input label
         * @type {String}
         */
        label: {
            type: String,
            default: '',
        },

        /**
         * Boolean defining if there should be a label
         * @type {String}
         */
        hasLabel: {
            type: Boolean,
            default: true,
        },

        /**
         * String defining the input placeholder
         * @type {String}
         */
        placeholder: {
            type: String,
            default: '',
        },

        /**
         * validation defining the rules to be applied
         * @type {String, Object}
         */
        rule: {
            type: [String, Object],
            default: '',
        },

        /**
        * validation scope in which the field resides
        * @type {String}
        */
        scope: {
            type: String,
            default: null,
        },

        /**
        * events when the validation should fire
        * @type {String}
        */
        validateOn: {
            type: String,
            default: 'input'
        },

        /**
         * description of the given input
         * @type {String}
         */
        description: {
            type: String,
            default: '',
        },

        step: {
            default: '1',
        },
        rows: {
            default: '5',
        },
        disabled: {
            type: Boolean,
            default: false
        },
        forcedError: {
            type: String,
            default: null,
        }
    },

    data() {
        return {
            localValue: this.value,
            inputCtaWidth: '1rem'
        };
    },


    methods: {
        update(e) {
            this.localValue = e.target.value;
            this.$emit('input', this.localValue);
        },
    },

    updated() {
        if (this.$refs.inputCta)
            this.inputCtaWidth = this.$refs.inputCta.clientWidth + 20 + 'px'
    },

    computed: {
        hasInputCta() {
            return !!this.$slots["input-cta"];
        },
        inputListeners: function () {
            return Object.assign({},
                this.$listeners,
                {
                    input: (e) => {
                        this.$emit('input', e.target.value);
                    }
                }
            )
        }
    },

    watch: {
        value() {
            this.localValue = this.value;
        },
    },
};
</script>
